/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Breadcrumbs, Button, ChevronLeftIcon } from "@forge/common";
import { useNavigate } from "react-router-dom";
import "./BreadCrumbsComponent.scss";

interface iProps {
  crumbs: any;
  backbutton: boolean;
  backButtonHandler?: () => void;
  onCrumbClick?: (value: { id: string; href?: string }) => void;
}

const BreadCrumbsComponent = (props: iProps) => {
  const navigate = useNavigate();

  const handleCrumbChange = (value: { id: string; href?: string }) => {
    if (props.onCrumbClick) {
      props.onCrumbClick(value);
    } else if (value?.href) {
      navigate(value.href);
    }
  };

  return (
    <>
      <div className="breadcrump_wrap">
        {props.backbutton && (
          <Button
            data-testid="back-button-breadcrumb"
            label="Schedule"
            onClick={() => {
              props?.backButtonHandler && props.backButtonHandler();
            }}
            size="regular"
            variant="quiet-secondary"
            className="p-0 h-auto w-auto icon-button"
          >
            {" "}
            <ChevronLeftIcon className="w-5 h-5" />{" "}
          </Button>
        )}
        <Breadcrumbs crumbs={props.crumbs} onChange={handleCrumbChange} />
      </div>
    </>
  );
};

export default BreadCrumbsComponent;
